import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

// Gatsby
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

// Components
import LargeArticle from './articles/large'
import MediumArticle from './articles/medium'

// Helpers
import { checkArray } from "../helpers/index"

const Article = ({ article: { title, intro, category, date, author, image } }) => (
  <div className="grid grid-cols-12 col-span-12 mb-12 bg-white hover:shadow-lg">
    <div className="col-span-12 md:col-span-10">
      <p className="bg-gray-900 text-white py-2 px-1 w-2/3 md:w-3/12 text-center tracking-wide text-sm">{category.toUpperCase()}</p>
      <div className="col-span-10 px-5 pb-2">
        <h6 className="my-2 text-2xl font-bold">{title}</h6>
        <p className="text-lg text-gray-700 font-light">{intro}</p>
        <p className="text-sm md:text-base"><span className="font-bold">{author.name}</span>, {date}</p>
      </div>
    </div>
    <div className="col-span-12 md:col-span-2">
      <Img fluid={image.childImageSharp.fluid} className="md:h-full md:w-full" objectFit="cover" />
    </div>
  </div>
)

Article.propTypes = {
  article: PropTypes.object.isRequired
}

const ArticleLarge = ({ article: { title, intro, category, date, author, image } }) => (
  <div className="col-span-12 md:col-span-6 mb-20 hover:shadow-lg bg-white">
    <Img fluid={image.childImageSharp.fluid} className="max-h-1/2-screen" objectFit="cover" />
    <div className="py-0">
      <p className="bg-gray-900 py-2 w-1/2 md:w-3/12 text-center text-white tracking-wide text-sm m-0 mb-4">{category.toUpperCase()}</p>
      <div className="col-span-10 px-5">
        <p className="text-gray-900 text-2xl font-bold tracking-wider my-0">{title}</p>
        <div className="text-gray-900">
          <h2 className="text-lg text-gray-700 leading-snug font-thin">{intro}</h2>
          <p className="text-base"><span className="font-bold">{author.name}</span>, {date}</p>
        </div>
      </div>
    </div>
  </div>
)

ArticleLarge.propTypes = {
  article: PropTypes.object.isRequired
}

const Research = () => {
  const [research, setResearchNews] = useState([])

  const data = useStaticQuery(graphql`
    query InvestigationArticles {
      investigacion: allStrapiArticle(filter: { category: { eq: "investigacion" } }, sort: {fields: createdAt, order: ASC}) {
        nodes {
          strapiId
          title
          intro
          category
          date(fromNow: true)
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
          author {
            name
            picture {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
`)

  useEffect(() => {
    if (data && data.investigacion) {
      setResearchNews(data.investigacion.nodes)
    }
  }, [data])

  return (

    <section className="grid grid-cols-12 bg-gray-300 lg:pt-10 pt-75">
      <h1 className="col-start-2 col-span-10 md:mt-56 text-4xl md:text-6xl tracking-wide font-bold text-gray-900">INVESTIGACIÓN</h1>
      <div className="col-start-2 col-span-10">
        <div className="grid grid-cols-12 gap-4 md:gap-12">
          {checkArray(research) && research.slice(0, 2).map(article => (
            <LargeArticle key={article.strapiId} article={article} />
          ))}
        </div>
      </div>

      <div className="col-span-12 bg-gray-200">
        <div className="grid grid-cols-12">
          <h1 className="col-start-2 col-span-10 text-4xl md:text-6xl font-bold text-gray-900 tracking-wide my-10">OTROS CASOS</h1>
          <div className="col-start-2 col-span-10">
            <div className="grid grid-cols-12">
              <div className="lg:col-span-8 col-span-12">
                {checkArray(research) && research.slice(2).map(article => (
                  <MediumArticle key={article.strapiId} article={article} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Research
